import { getResources } from "translation-resolver";
import { HttpBackendOptions } from "i18next-http-backend";
import { InitOptions } from "i18next/typescript/options";

interface CustomInitOptions extends InitOptions {
  backend?: HttpBackendOptions;
}

let base = import.meta.env.BASE_URL ?? "";
if (!base.endsWith("/")) {
  base += "/";
}
const BUILD_ID = import.meta.env.PUBLIC_BUILD_ID;
const path = "assets/translations/{{lng}}.json";
const versionSuffix = BUILD_ID ? `?v=${BUILD_ID}` : "";

const i18nOptions: CustomInitOptions = {
  backend: {
    loadPath: `${base}${path}${versionSuffix}`,
  },
  resources: getResources(),
  debug: import.meta.env.DEV && !import.meta.env.SSR,
  lng: "en",
  fallbackLng: "en",
};

export default i18nOptions;
